<template xmlns="http://www.w3.org/1999/html">
    <div class="form-group">
        <!-- <hero-banner :title="heroTitle" :show-icon="true"/> -->
        <section class="section pt-3">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-9 col-md-10 col-sm-12"  v-if="cancellationSuccess === false">
                        <div id="loader" v-if="isLoading">
                            <div class="spinner"></div>
                        </div>
                        <!---
                        <div class="section" data-test="info-session-section" v-if="!selected">
                            <h2>Tell us more about you</h2>
                            <div
                                v-bind:key="course.group_session_id"
                                v-for="course in courses"
                                class="course-container"
                            >
                                <p class="session-date ms-4">{{ course.course_name }}, {{ getDateFormat(course.start_date) }}</p>
                                <a v-if="course.application_status != 'Application' && course.application_status != 'Account registered Info session booked'" :id="`app-btn-${course.interaction_id}`" class="btn btn-secondary disabled" data-cy="btn-application">Completed</a>
                                <a v-else class="btn btn-secondary" :id="`app-btn-${course.interaction_id}`" data-cy="btn-application" :href="`/${course.product_level_1.replace(' ', '').toLowerCase()}-about-you/${course.interaction_id}`">Start now</a>
                            </div>
                        </div>
                        --->
                       
                        <div class="section">
                              <h2 v-if="feature_flags[0]['link_to_course'] === true || feature_flags[0]['link_to_course_resources'] === true || feature_flags[0]['link_to_post_programme'] === true">Your Courses</h2>
                            <div class="col-12 col-md card-group">
                             <div v-bind:key="card.title"
                                  v-for="card in filteredCourseCards"
                                 class="card shadow mb-5 me-3">
                                 <img :src="card.imageUrl" class="img-fluid" alt="" loading="lazy" />
                                  <div class="card-body">
                                  <h3><a :href="`/resources/${card.interactionCategory.toLowerCase()}/${card.productLevel.toLowerCase()}`">{{card.title}}</a></h3>
                                  <div class="pt-2" v-html="card.bodyText"></div>                               
                                <div class="pt-2">
                                    <br/>
                                <h3 data-testid="section-heading" class="mb-4">
                                   <a v-bind:href="`/resources/${card.interactionCategory.toLowerCase()}/${card.productLevel.toLowerCase()}`" class="cta__button">View more</a>
                                </h3>
                                </div>
                                </div>
                                </div>                  
                            </div>
                        </div>
                       
                        <h2 data-testid="paragraph-1" v-if="!selected" class="mb-5">
                        Your sessions
                        </h2>
                        <div data-test="info-session-section" v-if="!selected">

                            <!-- Booked sessions: nearest date first -->
                            <div v-if="bookedSessions.length">
                                <h3>Booked</h3>
                                <div
                                    v-bind:key="session.info_session_id"
                                    v-for="session in bookedSessions"
                                    class="mb-4"
                                >
                                    <div class="d-flex flex-row">
                                        <booked-sessions
                                           :start-date="session.start_date"
                                           :start-time="session.start_time"
                                           :end-time="session.end_time"
                                           :info-session-id="session.info_session_id"
                                           :participation-id="session.participation_id"
                                           :session-name="session.session_name"
                                           :selected="selected"
                                        />
                                        <button class="btn btn-primary btn-cancel mb-2" data-cy="btn-cancel" @click="selectSession(session)">Cancel session</button>
                                    </div>
                                </div>
                            </div>

                            <!-- Attended sessions: most recent first -->
                            <div v-if="attendedSessions.length">
                                <h3>Attended</h3>
                                <div
                                    v-bind:key="session.info_session_id"
                                    v-for="session in attendedSessions"
                                    class="mb-4"
                                >
                                    <div class="d-flex flex-row">
                                        <booked-sessions
                                           :start-date="session.start_date"
                                           :start-time="session.start_time"
                                           :end-time="session.end_time"
                                           :info-session-id="session.info_session_id"
                                           :session-name="session.session_name"
                                           :selected="selected"
                                        />
                                        <div class="btn btn-primary btn-attended d-flex align-items-center mb-2">Attended</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Cancelled sessions: most recently cancelled first -->
                            <div v-if="cancelledSessions.length">
                                <h3>Cancelled</h3>
                                <div
                                    v-bind:key="session.info_session_id"
                                    v-for="session in cancelledSessions"
                                    class="mb-4"
                                >
                                    <cancelled-sessions
                                        :start-date="session.start_date"
                                        :start-time="session.start_time"
                                        :end-time="session.end_time"
                                        :info-session-id="session.info_session_id"
                                        :session-name="session.session_name"
                                   />
                                </div>
                            </div>

                        </div>
                        <div id="cancelQuestions" v-if="selected">
                            <fieldset>
                                <legend>
                                    <h2 data-testid="section-heading" class="mb-4 pt-3">
                                      To complete cancellation, please select your reason for cancelling
                                    </h2>
                                </legend>
                                <div>
                                    <div class="form-check mb-4">
                                        <input class="form-check-input" id="cancellation-reason" name="cancellation-reason" type="radio" value="I have concerns and would like to speak to someone before attending" v-model="cancellationReason">
                                        <label for="cancellation-reason" class="form-check-label">
                                            I have concerns and would like to speak to someone before attending
                                        </label>
                                    </div>
                                    <div class="form-check mb-4">
                                        <input class="form-check-input" id="cancellation-reason-2" name="cancellation-reason" type="radio" value="I cannot make this day/time" v-model="cancellationReason">
                                        <label class="form-check-label" for="cancellation-reason-2">
                                            I cannot make this day/time
                                        </label>
                                    </div>
                                    <div class="form-check mb-4">
                                        <input class="form-check-input" id="cancellation-reason-3" name="cancellation-reason" type="radio" value="I don’t have the right technology to join" v-model="cancellationReason">
                                        <label class="form-check-label" for="cancellation-reason-3">
                                            I don’t have the right technology to join
                                        </label>
                                    </div>
                                    <div class="form-check mb-4">
                                        <input class="form-check-input" id="cancellation-reason-4" name="cancellation-reason" type="radio" value="I’m not interested in this info session but I am interested in another King’s Trust programme" v-model="cancellationReason">
                                        <label class="form-check-label" for="cancellation-reason-4">
                                            I’m not interested in this info session but I am interested in another King’s Trust programme
                                        </label>
                                    </div>
                                    <div class="form-check mb-4">
                                        <input class="form-check-input" id="cancellation-reason-5" name="cancellation-reason" type="radio" value="I’m not interested in this info session or any other info session at the King’s Trust" v-model="cancellationReason">
                                        <label class="form-check-label" for="cancellation-reason-5">
                                            I’m not interested in this info session or any other info session at the King’s Trust
                                        </label>
                                    </div>
                                    <div class="form-check mb-4">
                                        <input class="form-check-input" id="cancellation-reason-5" name="cancellation-reason" type="radio" value="I have found another opportunity outside the King’s Trust, course or job / I am in education, training, or employment" v-model="cancellationReason">
                                        <label class="form-check-label" for="cancellation-reason-5">
                                            I have found another opportunity outside the King’s Trust, course or job / I am in education, training, or employment
                                        </label>
                                    </div>
                                    <div class="form-check mb-4">
                                        <input class="form-check-input" id="cancellation-reason-5" name="cancellation-reason" type="radio" value="I cannot attend for a different reason" data-aria-controls="conditional-reason" v-model="cancellationReason">
                                        <label class="form-check-label" for="cancellation-reason-5">
                                            I cannot attend for a different reason
                                        </label>
                                    </div>
                                    <div v-if="cancellationReason === 'I cannot attend for a different reason'" class="form-group" id="conditional-reason">
                                        <div>
                                            <label class="form-check-label form-label" for="cancellation-reason-field">
                                                Please enter the different reason
                                            </label>
                                            <input v-model="cancellation_reason_more" class="form-control" id="cancellation-reason-field" name="cancellation-reason-field">
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <div v-if="cancellationReason" data-test="cancellationreason">
                                <button data-cy="confirm-cancel" class="btn btn-primary" @click="cancelSession()">Confirm cancellation</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="cancellationSuccess === true">
                        <div class="form-group">
                            <h2 data-testid="section-heading" class="mb-4">
                                Thank you, your session has been cancelled
                            </h2>
                        </div>
                        <h3 data-testid="section-heading" class="mb-4" v-if="bookingLink != null">
                                <a class="cta__button" :href=bookingLink>Book another session for this course</a>
                        </h3>
                        <h3 data-testid="section-heading" class="mb-4">
                            Alternatively <a href="/help">Get additional help</a>
                        </h3>
                        <br>
                    </div>
                </div>
            </div>
        </section>
    </div>
 </template>

 <script setup>
 import HeroBanner from "./HeroBanner"
 import BookedSessions from "./Registration/BookedSessions.vue";
 import axios from "axios";
 import CancelledSessions from "./Registration/CancelledSessions.vue";

import { ref, computed, defineProps } from "vue";

const CANCELLED_STATUSES = ['Place cancelled', 'Place cancelled - admin error'];

const props = defineProps({
    sessions: {
        type: Array
    },
    courses: Array,
    status: String,
    interaction_details: {
        type: Array
    },
    feature_flags: {
        type: Array
    },
    cards: {
        type: Array,
        default: () => ([])
    }
})

const filteredCourseCards = computed(() => {
    const flags = props.feature_flags?.[0] ?? {}
    const allowedCategories = new Set()

    if (flags.link_to_course === true) {
        allowedCategories.add('enquiry')
        allowedCategories.add('assessment')
    }

    if (flags.link_to_course_resources === true) {
        allowedCategories.add('on programme')
        allowedCategories.add('pre-programme')
    }

    if (flags.link_to_post_programme === true) {
        allowedCategories.add('progression support')
        allowedCategories.add('business advance')
    }

    if (!allowedCategories.size) {
        return []
    }

    return (props.cards ?? []).filter((card) => {
        const category = String(card?.interactionCategory ?? '').toLowerCase().trim()
        return allowedCategories.has(category)
    })

    

})

const info_session_id = ref(null)
const info_session_start_date = ref(null)
const info_session_start_time = ref(null)
const info_session_end_time = ref(null)
const info_session_name = ref(null)
const participation_id = ref(null)
const isLoading = ref(false)
const selected = ref(null)
const cancellationReason = ref(null)
const cancellation_reason_more = ref(null)
const cancellationSuccess = ref(false)
const bookingLink = ref(null)

const bookedSessions = computed(() =>
    (props.sessions ?? []).filter(s => !CANCELLED_STATUSES.includes(s.participation_status) && s.participation_status !== 'Attended')
)

const attendedSessions = computed(() =>
    (props.sessions ?? []).filter(s => s.participation_status === 'Attended')
)

const cancelledSessions = computed(() =>
    (props.sessions ?? []).filter(s => CANCELLED_STATUSES.includes(s.participation_status))
)

function getDateFormat(dateString) {
    const date = new Date(dateString)
    return date.toLocaleString('default', { weekday: "long", day: "numeric", month: 'long' })
}

function selectSession(info_session) {
    selected.value = info_session.info_session_id;
    info_session_id.value = info_session.info_session_id;
    info_session_start_date.value = info_session.start_date;
    info_session_start_time.value = info_session.start_time;
    info_session_end_time.value = info_session.end_time;
    participation_id.value = info_session.participation_id;
    info_session_name.value = info_session.session_name;
}

function cancelSession() {
    isLoading.value = true

    axios
    .post("/session/cancel", {
        'cancelReason': cancellationReason.value,
        'participationId': participation_id.value,
        'infoSessionId': info_session_id.value,
        'infoSessionName': info_session_name.value,
        'infoSessionStartDate': info_session_start_date.value,
        'infoSessionStartTime': info_session_start_time.value,
        'infoSessionEndTime': info_session_end_time.value,
        'cancellationReasonMore': cancellation_reason_more.value,
    })
    .then(response => {
        if(response.data.success === true) {
            cancellationSuccess.value = true
            bookingLink.value = response.data.bookingLink
        } else {
            console.log(response);
            window.location.href = "/cancellation-error"
        }
    })
    .catch((err) => {
        if (err.response) {
            console.log(err.response);
            window.location.href = "/cancellation-error"
        }
    });
}
</script>
<style scoped>
.course-container {
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    background-color: rgb(240 240 240);
    position: relative;
    display: inline-flex;
    width: 100%;
    height: 100%;
    border-bottom: 4px solid #0000;
    border-color: #1e1964;
    color: rgb(50, 50, 50);
}

.course-container .btn, .btn-container .btn {
    border-color: #1e1964 !important;
    background-color: #1e1964 !important;
    color: #fff !important;
}

.session-date {
    margin: 0 auto;
    display: flex;
}

.btn.btn-cancel {
    background-color: #28D796 !important;
    border-color: #28D796 !important;
    color: #1E1964 !important;
    font-size: 18px;
    width: 20%;
}

.btn-attended {
    background-color: #007ab3 !important;
    border-color: #007ab3 !important;
    color: #fff !important;
    font-size: 18px;
    cursor: default;
    width: 20%;
    justify-content: center;
}

@media screen and (max-width: 1200px) {
    .btn.btn-cancel, .btn-attended {
        width: 23%;
    }
}

@media screen and (max-width: 958px) {
    .btn.btn-cancel, .btn-attended {
        padding: 10px;
    }
}

@media screen and (max-width: 768px) {
    .btn.btn-cancel, .btn-attended {
        width: 25%;
    }
    .course-container {
        width: 75%;
    }
}
</style>

